import { ApplicationTypes, KickPlateBoltHoles, attachComponent, featureLabels } from 'metalworks-domain'

import {
  detailComponent,
  distanceDimensionComponent,
  entityHeaderComponent,
  propertyPageComponent,
} from '@salsita-ai/platform-project-sdk/domain'
import { DeleteEntityButton, ReplaceEntityDropdown } from '@salsita-ai/platform-project-sdk/react'

import { KickplateBoltHolePropertyPage } from '../ui/property-pages/KickPlateBoltHolePropertyPage'

export const kickPlateBoltHoleComponents = [
  // TODO: yaml
  attachComponent
    .withComponent(detailComponent, 'main')
    .withEntity('KickPlateBoltHoles')
    .attach(() => {
      return {
        title: featureLabels[KickPlateBoltHoles.type],
        subtitle: 'Bolt holes for horizontal edges.',
        description:
          'All holes are the same, their diameter can be adjusted as well as position of corner holes. Other holes are evenly spaced.',
        thumbnailUrl: '/thumbnails/circular-hole.png',
      }
    }),
  // TODO: yaml
  attachComponent
    .withComponent(distanceDimensionComponent, 'diameter')
    .withEntity('KickPlateBoltHoles')
    .attach(
      s => ({
        value: s.radius * 2,
        min: 0.5,
        max: Math.min(20, s.$plate.$maxFeatureSize.x, s.$plate.$maxFeatureSize.y),
        unit: 'mm',
      }),
      v => {
        return {
          // TODO: can this be diameter - it will not be possible to migrate to yaml
          radius: v.value / 2,
        }
      }
    ),
  attachComponent
    .withComponent(propertyPageComponent, 'box')
    .withEntity('KickPlateBoltHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      page: <KickplateBoltHolePropertyPage id={s.id} />,
    })),
  attachComponent
    .withComponent(entityHeaderComponent, 'main')
    .withEntity('KickPlateBoltHoles')
    .withFilter({
      navigationStates: [ApplicationTypes.NavigationState.Features, ApplicationTypes.NavigationState.FeatureList],
    })
    // TODO: memoEval
    .attach(s => ({
      // TODO: this now needs separate replace entity component
      primaryButton: <ReplaceEntityDropdown entityId={s.id} />,
      secondaryButton: <DeleteEntityButton entityId={s.id} />,
    })),
]
